// Curated imagery
export const IMG = {
  heroDish: "https://images.unsplash.com/photo-1663530761401-15eefb544889?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  gourmet1: "https://images.unsplash.com/photo-1519077336050-4ca5cac9d64f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  gourmet2: "https://images.unsplash.com/photo-1780181612148-20a394ff0dff?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  gourmet3: "https://images.unsplash.com/photo-1743193144044-fb58eb902b91?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  jollof1: "https://images.unsplash.com/photo-1665332195309-9d75071138f0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  jollof2: "https://images.unsplash.com/photo-1664992960082-0ea299a9c53e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  jollof3: "https://images.unsplash.com/photo-1664993101841-036f189719b6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  jollof4: "https://images.unsplash.com/photo-1665556899022-9761f95769e5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  restaurant1: "https://images.unsplash.com/photo-1709548145082-04d0cde481d4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  restaurant2: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  restaurant3: "https://images.unsplash.com/photo-1526069631228-723c945bea6b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const CUISINES = [
  { id: "west-african", name: "West African", tag: "Bold & smoky", img: IMG.jollof1, count: 42 },
  { id: "italian", name: "Italian", tag: "Rustic soul", img: "https://images.unsplash.com/photo-1760852927482-950c08eec15b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", count: 58 },
  { id: "indian", name: "Indian", tag: "Layered spice", img: "https://images.unsplash.com/photo-1542367592-8849eb950fd8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", count: 63 },
  { id: "thai", name: "Thai & SE Asian", tag: "Fresh heat", img: "https://images.unsplash.com/photo-1568882041008-c0954e91caba?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", count: 37 },
  { id: "japanese", name: "Japanese", tag: "Precision", img: "https://images.unsplash.com/photo-1552912470-ee2e96439539?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", count: 29 },
  { id: "mediterranean", name: "Mediterranean", tag: "Sun & olive", img: "https://images.unsplash.com/photo-1760445530191-55f1d7a8cfd6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", count: 46 },
];

export const CHEFS = [
  {
    id: "amara-okafor",
    name: "Amara Okafor",
    type: "chef",
    kitchen: "Ember & Yam",
    cuisine: "West African",
    city: "Lagos · London",
    img: "https://images.unsplash.com/photo-1769955817432-641929f613f0?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    cover: IMG.jollof1,
    rating: 4.9,
    reviews: 512,
    verified: true,
    years: 12,
    bio: "Amara built her name over open-flame parties in Lagos before bringing smoky, party-style jollof to a devoted London following. Every grain is toasted over wood fire.",
    signature: "Wood-fired Party Jollof",
    dishes: ["d1", "d5", "d7"],
  },
  {
    id: "marco-belli",
    name: "Marco Belli",
    type: "chef",
    kitchen: "Osteria Belli",
    cuisine: "Italian",
    city: "Bologna · NYC",
    img: "https://images.unsplash.com/photo-1574966740637-12c84035a4f2?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    cover: "https://images.unsplash.com/photo-1727355819370-5646696bf71d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    rating: 4.8,
    reviews: 388,
    verified: true,
    years: 18,
    bio: "Third-generation pasta maker rolling sfoglia by hand every morning. Marco's ragù simmers for nine hours before it ever meets a plate.",
    signature: "9-Hour Ragù Tagliatelle",
    dishes: ["d2", "d6"],
  },
  {
    id: "priya-nair",
    name: "Priya Nair",
    type: "chef",
    kitchen: "Curry Leaf Club",
    cuisine: "Indian",
    city: "Kochi · Toronto",
    img: "https://images.unsplash.com/photo-1759521296047-89338c8e083d?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    cover: "https://images.unsplash.com/photo-1589778655375-3e622a9fc91c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    rating: 4.9,
    reviews: 447,
    verified: true,
    years: 15,
    bio: "Priya grinds her own masalas daily, coaxing coastal Keralan flavour into every thali. No shortcuts, no jarred paste.",
    signature: "Kerala Coastal Thali",
    dishes: ["d3"],
  },
  {
    id: "sakura-restaurant",
    name: "Sakura House",
    type: "restaurant",
    kitchen: "Sakura House",
    cuisine: "Japanese",
    city: "Osaka · Berlin",
    img: IMG.restaurant2,
    cover: IMG.gourmet2,
    rating: 4.7,
    reviews: 274,
    verified: true,
    years: 9,
    bio: "An intimate 12-seat counter serving omakase built entirely around the day's market. Precision and restraint in every course.",
    signature: "Seasonal Omakase",
    dishes: ["d4", "d8"],
  },
];

export const DISHES = [
  { id: "d1", name: "Wood-Fired Party Jollof", chef: "amara-okafor", cuisine: "West African", price: 18, img: IMG.jollof1, rating: 4.9, spicy: 3, tags: ["Signature", "Smoky"], desc: "Toasted long-grain rice cooked over wood fire in a deep pepper-tomato base, finished with fried plantain." },
  { id: "d2", name: "9-Hour Ragù Tagliatelle", chef: "marco-belli", cuisine: "Italian", price: 22, img: "https://images.unsplash.com/photo-1727355819370-5646696bf71d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000", rating: 4.8, spicy: 0, tags: ["Handmade", "Slow-cooked"], desc: "Hand-rolled sfoglia tagliatelle folded through a nine-hour beef and pork ragù." },
  { id: "d3", name: "Kerala Coastal Thali", chef: "priya-nair", cuisine: "Indian", price: 20, img: "https://images.unsplash.com/photo-1542367592-8849eb950fd8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000", rating: 4.9, spicy: 2, tags: ["Vegetarian option", "Freshly ground"], desc: "A tray of coastal curries, thoran, rice and hand-ground masalas — a full Keralan journey." },
  { id: "d4", name: "Seasonal Omakase Set", chef: "sakura-restaurant", cuisine: "Japanese", price: 65, img: IMG.gourmet2, rating: 4.7, spicy: 0, tags: ["Chef's choice", "Market fresh"], desc: "A guided sequence of nigiri and small plates built around the morning's market." },
  { id: "d5", name: "Smoky Suya Skewers", chef: "amara-okafor", cuisine: "West African", price: 14, img: "https://images.unsplash.com/photo-1568882041008-c0954e91caba?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000", rating: 4.8, spicy: 3, tags: ["Grilled", "Street classic"], desc: "Charred beef skewers dusted generously with house yaji spice blend." },
  { id: "d6", name: "Truffle Cacio e Pepe", chef: "marco-belli", cuisine: "Italian", price: 24, img: "https://images.unsplash.com/photo-1519077336050-4ca5cac9d64f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000", rating: 4.7, spicy: 0, tags: ["Vegetarian", "Rich"], desc: "Silky pecorino and cracked pepper emulsion over fresh tonnarelli, shaved black truffle." },
  { id: "d7", name: "Egusi & Pounded Yam", chef: "amara-okafor", cuisine: "West African", price: 17, img: IMG.jollof3, rating: 4.8, spicy: 2, tags: ["Comfort", "Traditional"], desc: "Melon-seed stew rich with greens and smoked fish, served with soft pounded yam." },
  { id: "d8", name: "Charred Miso Plate", chef: "sakura-restaurant", cuisine: "Japanese", price: 28, img: IMG.gourmet3, rating: 4.6, spicy: 1, tags: ["Umami", "Signature"], desc: "Market fish glazed in aged miso and flame-charred, plated with pickled seasonal vegetables." },
];

export const PROMOS = [
  { id: "p1", title: "First bite on us", detail: "20% off your first order from any verified chef.", code: "SAVOR20", accent: "#d00000" },
  { id: "p2", title: "Jollof Wars Week", detail: "Compare 6 legendary jollof recipes. Free delivery.", code: "JOLLOF", accent: "#f5a623" },
  { id: "p3", title: "Sunday Supper Club", detail: "Multi-course chef menus, up to 4 guests.", code: "SUPPER", accent: "#d00000" },
];

export const TESTIMONIALS = [
  { id: "t1", name: "Dara A.", city: "London", text: "Amara's party jollof tastes exactly like the ones from weddings back home. I actually teared up a little.", rating: 5 },
  { id: "t2", name: "Lucas M.", city: "New York", text: "Marco's ragù is the closest thing to my nonna's kitchen I've found outside Italy. Unreal.", rating: 5 },
  { id: "t3", name: " Living-in-Toronto", city: "Toronto", text: "Priya's thali is a full experience. You can taste that every spice was ground that morning.", rating: 5 },
  { id: "t4", name: "Kenji T.", city: "Berlin", text: "Sakura House gave me the omakase night I'd been missing since leaving Osaka.", rating: 5 },
];

export const JOLLOF = {
  hero: IMG.jollof1,
  title: "Jollof",
  subtitle: "The one-pot dish that started a friendly war across a continent.",
  story:
    "Born in the Senegambian region as thieboudienne and reimagined across West Africa, jollof is more than rice cooked in a rich pepper-and-tomato base — it is identity, pride and endless debate. Ask a Nigerian and a Ghanaian whose jollof reigns supreme and you'll understand.",
  origins: [
    { region: "Nigeria", note: "Smoky 'party jollof' — long grain, deep char from the pot, often finished over wood fire.", accent: "#d00000" },
    { region: "Ghana", note: "Fragrant and aromatic, built on jasmine or basmati rice with warm spices.", accent: "#f5a623" },
    { region: "Senegal", note: "Thieboudienne — the original, layered with fish, vegetables and broken rice.", accent: "#d00000" },
  ],
  versions: [
    { chef: "amara-okafor", style: "Nigerian party style", img: IMG.jollof1 },
    { chef: "amara-okafor", style: "Smoked & spiced", img: IMG.jollof3 },
    { chef: "priya-nair", style: "Coastal fusion", img: IMG.jollof4 },
  ],
  facts: [
    { k: "Base", v: "Blended scotch bonnet, red pepper, tomato & onion" },
    { k: "The debate", v: "Nigeria vs Ghana, since forever" },
    { k: "World Jollof Day", v: "August 22nd" },
  ],
};

export const DISCOVERY = [
  { id: "a1", cat: "Deep Dive", title: "The Wood-Fire Revival", excerpt: "Why a new wave of indie chefs are cooking over open flame — and how it changes everything.", img: IMG.gourmet1, read: "6 min" },
  { id: "a2", cat: "Origins", title: "Mapping the Spice Routes", excerpt: "From Kerala to Zanzibar, tracing the trade that built the world's boldest kitchens.", img: "https://images.unsplash.com/photo-1589778655375-3e622a9fc91c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", read: "8 min" },
  { id: "a3", cat: "Chef Q&A", title: "Marco Belli on the Nine-Hour Ragù", excerpt: "Patience, one wooden spoon, and never — ever — rushing the soffritto.", img: "https://images.unsplash.com/photo-1727355819370-5646696bf71d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", read: "5 min" },
  { id: "a4", cat: "Culture", title: "Jollof, and the Joy of Arguing About Food", excerpt: "A love letter to the friendliest rivalry in global cuisine.", img: IMG.jollof2, read: "7 min" },
];

export function getChef(id) {
  return CHEFS.find((c) => c.id === id);
}
export function getDishesByChef(id) {
  return DISHES.filter((d) => d.chef === id);
}
